<!-- <div class="row"> -->
<!-- <div class="col-10">
        <nav class="navbar navbar-expand-lg ">
           <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </nav>
    </div> -->
<!-- <span class = "helplogout">
        <div class="col-2">
          <a class="getHelp">Need&nbsp;Help</a>
      </div> -->
<!-- </div> -->
<div class="container-fluid px-lg-5">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-sm">
        <a class="navbar-brand" (click)="OnLogoClick()">
          <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </a>

        <ul class="nav ml-auto">
          <li><a class="pl-4" (click)="OnLogoClick()">Need&nbsp;Help</a></li>

          <!-- <li>
              <a class="pl-4" routerLink="/logout" routerLinkActive="active">Logout</a>
          </li> -->
        </ul>
      </nav>
    </div>
  </div>
</div>

<br>
<br>
<div *ngIf="registerProfilError" class="success">
  <p>You have not succesfully registered.</p>
  <a class="btn btn-success" routerLink="/landing">Go To Home Page</a>
</div>
<div *ngIf="registerProfileSuccess" class="success">
  <p>You have been succesfully registered.</p>
  <a class="btn btn-success" routerLink="/landing">Go To Home Page</a>
</div>

<div *ngIf="registerProfile" class="container">
  <div class="stepwizard">
    <div class="stepwizard-row setup-panel">
      <div class="stepwizard-step col-xs-3">
        <a type="button" class="btn btn-success btn-circle">1</a>
        <p class="highlight"><small>step-1</small></p>
      </div>
      <div class="stepwizard-step col-xs-3">
        <a type="button" class="btn btn-success btn-circle">2</a>
        <p><small>step-2</small></p>
      </div>
      <div class="stepwizard-step col-xs-3">
        <a type="button" class="btn btn-success btn-circle">3</a>
        <p><small>step-3</small></p>
      </div>
      <div class="stepwizard-step col-xs-3">
        <a type="button" class="btn btn-success btn-circle">4</a>
        <p><small>step-4</small></p>
      </div>
    </div>
  </div>
  <br>
  <br>

  <!-- <p class="mandatorynote"> Fields with * symbol are mandatory one.</p> -->

  <form role="form" (ngSubmit)="OnRegister(f1.value)" #f1="ngForm">
    <div *ngIf="step1" class="panel panel-primary setup-content" id="step-1">

      <!-- <div class="row justify-content-center">
          <div class="col-md-8">
              <div class="card">
                  <div class="card-header">Profile Management</div>
                  <div class="card-body"> -->

      <div class="row">

        <!-- heading section left side on page -->
        <!-- <div class="col-lg-6">
                                <h1>Create your Profile.</h1>
                                <h3>Complete your Profile as Developer and get started.</h3>
                            </div> -->
        <!-- Form section -->

        <div class="col-lg-12">

          <p class="mandatorynote"> Fields with * symbol are mandatory one.</p>
          <h2 class="profile-heading">PROFILE</h2>

          <div class="form-row">
            <div class="form-group col-6">
              <label for="emailAddress" class="required">Email Address</label>
              <input type="email" class="form-control" name="EMail" placeholder="Enter Email Address"
                     [(ngModel)]="EMail"
                     pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
                     #email=ngModel required />
              <span *ngIf="!email.valid" class="msgred">
                Ensure your Email Address is in valid
                format.
              </span>
            </div>
            <div class="form-group col-6">
              <button type="button" class="btn btn-primary verification"
                      (click)="add();onEmailCommunication()">
                Send Verification Code
              </button>
            </div>

            <p *ngIf="emailValid" class="msgred">Your Email Address is not valid. Please Check.</p>
            <!-- <div class="showInputField"></div><br> -->
            <input *ngIf="otptext" type="text" class="form-control otptext"
                   placeholder="Enter Verification Code" name="otp" [(ngModel)]="otp" required />
            <p *ngIf="otpVerify">Email Address has been Verified Succesfully</p>
            <p *ngIf="otpVerifyFail" class="msgred">Email has not been Verified</p>
            <!-- <button *ngIf="verify" type="button" class="btn btn-primary verification"
                (click)="onOtpVerify()">
                Verify</button> -->
            <!-- <div class="showResetButton btn btn-primary "></div> -->
          </div>
          <button *ngIf="verify" type="button" class="btn btn-primary verification"
                  (click)="onOtpVerify()">
            Verify
          </button>
          <br>
          <br>

          <div class="form-row">

            <div class="form-group col-md-6">
              <label for="Password" class="required">Password</label>
              <input type="password" class="form-control" name="Password" (keyup)="onPwdkey()"
                     placeholder="Enter Password"
                     [(ngModel)]="Password"
                     pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@#$%^&*-_!~]).{8,15}$"
                     #password=ngModel required />
              <div *ngIf="pwdSendVerification" class="msgred">Please click on SendVerificationCode first!!</div>
              <!-- <span ng-show="!password.valid && password.touched" >Please enter Valid Password.</span> -->
              <div *ngIf="password.invalid" class="msgred">
                <p>The password must be between 8 and 15 characters.</p>
                <p>The password must have at least 3 of the following:</p>
                <p> - a lowercase,uppercase,digit and special character.</p>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="ConfirmPassword" class="required">Confirm Password</label>
              <input type="password" class="form-control" placeholder="Enter Confirm Password"
                     [(ngModel)]="ConfirmPassword" name="confirm" (keyup)="onKeyUp($event)" required />
              <p *ngIf="cpwd" class="msgred">Confirm Password is not matched.</p>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="lastName" class="required">Display Name</label>
              <input type="text" class="form-control" placeholder="Enter Display Name"
                     [(ngModel)]="DisplayName" name="DisplayName" required />
            </div>
            <div class="form-group col-md-4">
              <label for="firstName" class="required">FirstName</label>
              <input type="text" class="form-control" id="firstName" placeholder="Enter First Name"
                     [(ngModel)]="FirstName" name="FirstName" required />
            </div>
            <div class="form-group col-md-4">
              <label for="lastName" class="required">LastName</label>
              <input type="text" class="form-control" id="lastName" placeholder="Enter Last name"
                     [(ngModel)]="Lastame" name="Lastame" required />
            </div>
          </div>

          <div class="form-row">

            <div class="form-group col-md-6">
              <label for="address" class="required">Street Address</label>
              <input type="text" class="form-control" placeholder="Enter StreetAddress"
                     [(ngModel)]="StreetAddress" name="StreetAddress" required />
            </div>

            <div class="form-group col-md-6">
              <label for="inputCity" class="required">City</label>
              <input type="text" class="form-control" placeholder="Enter City" [(ngModel)]="City"
                     name="City" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="Country" class="required">Country</label>
              <select class="form-control" [(ngModel)]="Country" name="Country" required>
                <option *ngFor="let item of loadedCountry" [value]="item.country_Name">
                  {{item.country_Name}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="State" class="required">State</label>
              <input type="text" class="form-control" placeholder="Enter State" [(ngModel)]="State"
                     name="State" required>
              <!-- <label for="State" class="required">State</label> -->
              <!-- <select class="form-control" [(ngModel)]="State" name="State" required>
                  <option selected>Choose...</option>

                  <option *ngFor="let items of loadedState" [value]="items.id">
                      {{items.state_Name}}
                  </option>
              </select> -->
              <!-- <input type="text" class="form-control" id="Street" placeholder="test"> -->
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col">
              <label for="" class="required">ZipCode</label>
              <input type="text" class="form-control" placeholder="Enter ZipCode" [(ngModel)]="ZipCode"
                     name="ZipCode" required />
            </div>

            <div class="form-group col ">
              <label for="Phone" class="required">Phone Number</label>
              <input type="text" class="form-control" id="Phone" placeholder="Enter Phone Number"
                     [(ngModel)]="PhoneNumber" name="PhoneNumber"
                     pattern="^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$" #phone=ngModel required />
              <p *ngIf="!phone.valid" class="msgred">
                Phone Number must contain 10 digits and must be in
                format of 123-456-7890.
              </p>
            </div>
          </div>
          <fieldset [disabled]="otpVerifyFail">
            <button type="button" [disabled]="!f1.valid" class="btn btn-primary firstNextBtn"
                    (click)="nextForm();saveValues(f1.value)">
              Next
            </button>
          </fieldset>

          <!-- <button type="submit" [disabled]="!f.valid" class="btn btn-primary"><i
                          class="fa fa-user-circle"></i>
                      Submit</button> -->
        </div>
      </div>

      <!-- </div>
              </div>
          </div>
      </div> -->
      <!-- </div>
      </div> -->
    </div>

    <div *ngIf="step2" class="panel panel-primary setup-content" id="step-2">

      <p class="mandatorynote"> Fields with * symbol are mandatory one.</p>
      <div class="panel-heading">
        <h3 class="panel-title">Organization</h3>
      </div>

      <div class="col-lg-12">

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="OrganizationName" class="required">OrganizationName</label>
            <input type="text" class="form-control" placeholder="Enter OrganizationName"
                   [(ngModel)]="OrganizationName" name="OrganizationName" required />
          </div>

          <div class="form-group col-md-6">
            <label for="OrganizationTaxID" class="required">OrganizationTaxID</label>
            <input type="text" class="form-control" placeholder="Enter OrganizationTaxID"
                   [(ngModel)]="OrganizationTaxID" name="OrganizationTaxID" required />
          </div>
          <div class="form-group col-md-6">
            <label for="OrgStreetAddress">Organization StreetAddress</label>
            <input type="text" class="form-control" placeholder="Enter OrgStreetAddress"
                   [(ngModel)]="OrgStreetAddress" name="OrgStreetAddress" />
          </div>
          <div class="form-group col-md-6">
            <label for="OrgCity">Organization City</label>
            <input type="text" class="form-control" placeholder="Enter OrgCity" [(ngModel)]="OrgCity"
                   name="OrgCity">
          </div>
          <div class="form-row orgleftmargin">
            <div class="form-group col-md-6">
              <label for="Organization Country">Organization Country</label>
              <select class="form-control" [(ngModel)]="selectedgetCountryData" name="OrgCountry">
                <option *ngFor="let item of loadedCountry">
                  {{item.country_Name}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="Organization State">Organization State</label>
              <input type="text" class="form-control" placeholder="Enter State" [(ngModel)]="OrgState"
                     name="OrgState" />
              <!-- <label for="Organization State" class="required">Organization State</label>
              <select class="form-control" [(ngModel)]="State" name="OrgState" required>
                  <option selected>Choose...</option>

                  <option *ngFor="let items of loadedState" [value]="items.id">
                      {{items.state_Name}}
                  </option>
                  <option selected>Choose...</option>
                  <option>Haryana</option>
              </select> -->
            </div>

            <div class="form-group col-lg-6">
              <label for="">Organization ZipCode</label>
              <input type="text" class="form-control" placeholder="Enter OrgZipCode"
                     [(ngModel)]="OrgZipCode" name="OrgZipCode" />
            </div>
            <div class="form-group col-lg-6">
              <label for="">Alternative Email</label>
              <input type="text" class="form-control" placeholder="Enter AltEmail"
                     [(ngModel)]="OrgAltEmail" name="OrgAltEmail"
                     pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
                     #altemail=ngModel />
              <span *ngIf="!altemail.valid" class="msgred">
                Ensure your Email Address is in valid
                format.
              </span>
            </div>

            <div class="form-group col-lg-6">
              <label for="">Phone Number</label>
              <input type="text" class="form-control" placeholder="Enter Phone Number"
                     [(ngModel)]="OrgPhoneNumber" name="OrgPhoneNumber"
                     pattern="^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$" #phone=ngModel />

              <p *ngIf="!phone.valid" class="msgred">
                Phone Number must contain 10 digits in format
                (123-456-7890).
              </p>
            </div>
            <!-- <div class="form-row">
                <div class="form-group col-lg-6">
                    <label for="">Organization ZipCode</label>
                    <input type="text" class="form-control" placeholder="Enter OrgZipCode"
                        [(ngModel)]="OrgZipCode" name="OrgZipCode" required />
                </div>
                <div class="form-group col-lg-6">
                    <label for="">Alternative Email</label>
                    <input type="text" class="form-control" placeholder="Enter AltEmail"
                        [(ngModel)]="OrgAltEmail" name="OrgAltEmail" required />
                </div>
            </div> -->
            <br>
            <br>
            <div class="form-group col-10">

              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="gridCheck" name="policy_chk"
                         ngModel />
                  <label class="form-check-label" for="gridCheck">
                    Privacy Policy
                  </label>
                </div>
              </div>

              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input type="text" class="form-control textarea" name="Policy_Url" id="policy"
                         placeholder="Enter Privacy Policy Url" [(ngModel)]="Policy_Url" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="gridCheck"
                       name="InformationSecurityPolicy" [(ngModel)]="InformationSecurityPolicy" />
                <label class="form-check-label" for="gridCheck">
                  Information Security Policy
                </label>
              </div>
            </div>

            <div class="form-group col-10">

              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input carincheck" type="checkbox" id="gridCheck"
                         name="carin" ngModel />
                  <label class="form-check-label" for="gridCheck">
                    Application’s CARIN Bio URL
                  </label>
                </div>
              </div>

              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input type="text" class="form-control textarea" name="Carin_Bio_Url"
                         id="Carin_Bio_Url" placeholder="Enter Application’s CARIN Bio URL"
                         [(ngModel)]="Carin_Bio_Url" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <br>

        <button type="button" class="btn btn-primary prvBtn" (click)="prevFromOrg()"> Previous</button>

        <button type="button" [disabled]="!f1.valid" class="btn btn-primary nextBtn"
                (click)="clearLoadedQuestions();nextOnOrgForm();saveOrgValues(f1.value)">
          Next
        </button>
        <!-- <button type="submit" [disabled]="!f1.valid" class="btn btn-primary"
        (click) = "saveOrgValues(f1.value)"><i class="fa fa-user-circle"></i>
            Submit</button> -->
      </div>
    </div>

    <div *ngIf="step3" class="panel panel-primary setup-content" id="step-3">
      <div class="panel-heading">
        <p>
          Blue Cross & Blue Shield of Rhode Island (BCBSRI) asks that any Application (App) developer
          requesting to access BCBSRI’s Patient Access API attest to compliance with the following statements.
          If you do not attest to compliance with these statements, we will inform any member that requests
          her/his protected health data using your App of the non-compliance and suggest that the member
          select an App that has attested to complying with these statements
        </p>
        <h3 class="panel-title">Questions</h3>
      </div>
      <div class="panel-body">

        <div class="row" *ngFor="let questions of loadedQuestions;let i = index">
          <table>
            <tr>

              <td>
                <input type="checkbox" class="quescheck" id="" name=""
                       (change)="isSelected(questions.id)" [value]='questions.id'>
              </td>
              <td>
                <div [innerHTML]="questions.questionText"></div>
              </td>
            </tr>

            <!-- <div class="col-10 checkbox-inline"> -->
            <!-- {{htmlText}}
            {{ questions.questionText }} -->
            <!-- </div> -->
          </table>
        </div>

        <button type="button" class="btn btn-primary prvBtn" (click)="nextForm()">Previous</button>

        <button class="btn btn-primary nextBtn" type="button"
                (click)="nextOnQuesForm();saveQuestionValues()">
          Next
        </button>
      </div>
    </div>

    <div *ngIf="step4" class="panel panel-primary setup-content" id="step-4">
      <p class="mandatorynote"> Fields with * symbol are mandatory one.</p>
      <div class="panel-heading">
        <h3 class="panel-title">TERMS OF CONDITIONS</h3>
        <h5>Please Check Terms and Conditions before Submit.</h5>
      </div>
      <br>
      <div class="panel-body">
        <div class="form-group">

          <div class="cols-sm-10">
            <div class="input-group">
              <span class="input-group-addon"></span>

              <div class=WordSection1>
                <div class="bullet-margin">
                  <p style="text-align: center;"><b>Developer Portal Terms and Conditions</b></p>

                  <p>
                    As a condition of using the Developer Portal created by Blue
                    Cross &amp; Blue Shield of Rhode Island (BCBSRI), all registrants to the
                    Developer Portal (Registrant) agree to the following:
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>
                    Registrant agrees to only use the API to retrieve individual
                    member data at the request of the member, and only when the member has
                    authorized such access via a HIPAA-qualified authorization.  Registrant will
                    cease to access data if the member consent is revoked.  Registrant will notify
                    BCBSRI if any consent is revoked.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant agrees to use data accessed through the API only in
                    accordance with applicable law, the terms of its privacy policy and the terms
                    of the member consent.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant agrees to keep its credentials for the Developer
                    Portal confidential.  Assignment of credentials is not permitted.  Registrant
                    will notify BCBSRI of any change in control and submit a new registration
                    application.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant will notify member of any breach or misuse of data as
                    required by state and federal laws.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>
                    Registrant will notify BCBSRI immediately of any security
                    incident that may impact the security of BCBSRI’s systems or data.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant will indemnify BCBSRI for any and all claims, damages
                    or expenses, including but not limited to attorneys’ fees resulting from
                    Registrant’s improper use of the API, improper disclosure of any data accessed
                    through the API, or any violation of the member’s consent, the terms of this
                    agreement, or any applicable laws.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant agrees that in any dispute between Registrant and
                    BCBSRI, Rhode Island law will apply without regard to conflict of law
                    principles, and jurisdiction will be appropriate in any Rhode Island state or
                    federal court only.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Registrant acknowledges that data accessed through the API is
                    provided with no warranty as to accuracy, and BCBSRI does not guarantee
                    uninterrupted access to the API.  Registrant expressly waives any right to seek
                    damages from BCBSRI related to Registrant’s use of the API or denial of access
                    to the API.
                  </p>

                  <p>BCBSRI retains the right to:</p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Limit access to the API at any time in its sole discretion as
                    necessary to protect BCBSRI’s system or prevent abuse.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Conduct a security assessment of any registered application, and
                    provide information to the member as to the outcome of the assessment.  In the
                    event that BCBSRI determines that allowing an application to connect or remain
                    connected to the API would present an unacceptable level of risk to the
                    security of protected health information on BCBSRI’s system, BCBSRI reserves
                    the right to deny access to the API.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Validate and authenticate member’s identity and consent before
                    allowing access to the API.
                  </p>

                  <p>
                    <span style='font-family:Symbol'>
                      ·<span style='font:7.0pt "Times New Roman"'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </span>Revoke access to the API if registrant provides any false
                    information in its registration application, engages in any inappropriate use
                    of the API, or violates the terms of the member’s consent, these terms and
                    conditions or any applicable law.
                  </p>
                </div>
                <!-- <textarea readonly class="form-control textarea" name="terms" id="terms" placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                example using twig for php framework symfony :"></textarea> -->
              </div>
              <!-- <textarea readonly class="form-control textarea" name="terms" id="terms" placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

              If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

              example using twig for php framework symfony :"></textarea> -->
            </div>
          </div>
          <br>

          <div class="form-group">
            <div class="form-check">
              <input [(ngModel)]="CheckedTerms" #terms_check="ngModel"
                     (change)="checkboxTermsClicked(CheckedTerms)" #terms_check1="ngModel"
                     class="form-check-input" type="checkbox" id="gridCheck" name="CheckedTerms" ngModel
                     required />
              <label class="form-check-label required" for="gridCheck">
                Terms and Conditions
              </label>
            </div>
          </div>
        </div>

        <!-- <div class="form-group"> -->
        <!-- <div class="cols-sm-10"> -->
        <!-- <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="CheckedCodeConduct" #cod_check="ngModel"
                            (change)="checkboxCodeConductClicked(CheckedCodeConduct)" class="form-check-input"
                            type="checkbox" id="gridCheck" name="CheckedCodeConduct" ngModel required />
                        <label class="form-check-label required" for="gridCheck">
                            Code of Conduct
                        </label>
                    </div>
                </div> -->
        <!-- <div class="input-group">
                    <span class="input-group-addon"></span>

                    <div class=WordSection1>

                        <p class=MsoNormal>Developer Portal Code Of Conduct</p>

                        <p class=MsoNormal>As a condition of using the Developer Portal created by Blue
                            Cross &amp; Blue Shield of Rhode Island (BCBSRI), all registrants to the
                            Developer Portal (Registrant) agree to the following:</p>

                        <p class=MsoListParagraphCxSpFirst style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant agrees to only use the API to retrieve individual
                            member data at the request of the member, and only when the member has
                            authorized such access via a HIPAA-qualified authorization.  Registrant will
                            cease to access data if the member consent is revoked.  Registrant will notify
                            BCBSRI if any consent is revoked.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant agrees to use data accessed through the API only in
                            accordance with applicable law, the terms of its privacy policy and the terms
                            of the member consent.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant agrees to keep its credentials for the Developer
                            Portal confidential.  Assignment of credentials is not permitted.  Registrant
                            will notify BCBSRI of any change in control and submit a new registration
                            application.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant will notify member of any breach or misuse of data as
                            required by state and federal laws.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant will notify BCBSRI immediately of any security
                            incident that may impact the security of BCBSRI’s systems or data.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant will indemnify BCBSRI for any and all claims, damages
                            or expenses, including but not limited to attorneys’ fees resulting from
                            Registrant’s improper use of the API, improper disclosure of any data accessed
                            through the API, or any violation of the member’s consent, the terms of this
                            agreement, or any applicable laws.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant agrees that in any dispute between Registrant and
                            BCBSRI, Rhode Island law will apply without regard to conflict of law
                            principles, and jurisdiction will be appropriate in any Rhode Island state or
                            federal court only.</p>

                        <p class=MsoListParagraphCxSpLast style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Registrant acknowledges that data accessed through the API is
                            provided with no warranty as to accuracy, and BCBSRI does not guarantee
                            uninterrupted access to the API.  Registrant expressly waives any right to seek
                            damages from BCBSRI related to Registrant’s use of the API or denial of access
                            to the API. </p>

                        <p class=MsoNormal>BCBSRI retains the right to:</p>

                        <p class=MsoListParagraphCxSpFirst style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Limit access to the API at any time in its sole discretion as
                            necessary to protect BCBSRI’s system or prevent abuse.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Conduct a security assessment of any registered application, and
                            provide information to the member as to the outcome of the assessment.  In the
                            event that BCBSRI determines that allowing an application to connect or remain
                            connected to the API would present an unacceptable level of risk to the
                            security of protected health information on BCBSRI’s system, BCBSRI reserves
                            the right to deny access to the API.</p>

                        <p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Validate and authenticate member’s identity and consent before
                            allowing access to the API.</p>

                        <p class=MsoListParagraphCxSpLast style='text-indent:-.25in'><span
                                style='font-family:Symbol'>·<span
                                    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span>Revoke access to the API if registrant provides any false
                            information in its registration application, engages in any inappropriate use
                            of the API, or violates the terms of the member’s consent, these terms and
                            conditions or any applicable law.</p>
                    </div>
                </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <button type="button" class="btn btn-primary prvBtn" (click)="clearLoadedQuestions();nextOnOrgForm()">
          Previous
        </button>

        <button type="submit" [disabled]="!f1.valid" class="btn btn-success nextBtn">
          Submit
        </button>
      </div>
    </div>
  </form>
</div>
<br>
<div>
  <app-footer></app-footer>
</div>
